import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeModal: null,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setActiveModal: (state, action) => {
      state.activeModal = action.payload;
    },
    clearActiveModal: (state) => {
      state.activeModal = null;
    },
  },
});

export const { setActiveModal, clearActiveModal } = globalSlice.actions;
export const selectActiveModal = (state) => state.global.activeModal;
export default globalSlice.reducer;
